import { Registry } from '@react-registry'

export const code = () => {
    return {
        type: 'code'
    }
}

Registry.register(code, { id: 'PRE', registry: 'deserializer' })